module.exports = __webpack_public_path__ + "img/ar.0a5223de.png";